import React from 'react';

import Button from 'components/shared/Button/Button';

const AddPayerModalHeader = ({ breadcrumb, requestNewPayerTab, onRequestNewPayer }) => {
  if (breadcrumb?.step !== 0) return null;

  const handleRequestNewPayer = () => {
    if (breadcrumb?.push && requestNewPayerTab) {
      breadcrumb.push(requestNewPayerTab);
      onRequestNewPayer();
    }
  };

  return (
    <Button
      variant="link"
      size="small"
      color="neutral"
      icon="add-square-mono"
      text="Request new payer"
      className="mr-3 h-6"
      onClick={handleRequestNewPayer}
    />
  );
};

export default AddPayerModalHeader;
